// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table.vgt-table tr {\n  cursor: pointer;\n}\ntable.vgt-table tr:hover {\n  background-color: #f1f1f1;\n}", ""]);
// Exports
module.exports = exports;
